var _radialGradient, _clipPath, _clipPath2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaikinOnecta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(0 14.6 -14.6 0 24 30)",
    gradientUnits: "userSpaceOnUse",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#f5a33d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#dc2602"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#142b3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#0057b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833333,
    stopColor: "#37b3da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#fff"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 4.4h40v8.4h-40z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 48,
    rx: 8,
    width: 48
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24 44.6c8.0634 0 14.6-6.5366 14.6-14.6s-6.5366-14.6-14.6-14.6c-8.0633 0-14.59998 6.5366-14.59998 14.6s6.53668 14.6 14.59998 14.6zm.05-3.3c6.5998 0 11.95-5.3726 11.95-12s-5.3502-12-11.95-12-11.95 5.3726-11.95 12 5.3502 12 11.95 12z",
    fill: "url(#a)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.1111 4.4h-9.1111v8.4z",
    fill: "#44c8f5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.55421 4.4h-4.55421v4.20134z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.8315 6.223-1.1892 4.7513h2.1006l1.1878-4.7513zm-4.7985 2.75394h-.4819l.7772-1.37093.2523 1.37093zm-.2993-2.75394-2.702 4.7513h1.3893l.4483-.7914h1.9288l.1436.7914h2.0509l-.8711-4.7513zm14.6921 0-1.1866 4.7513h2.1006l1.1866-4.7513zm-.9382 0h-2.153l-1.8026 1.55471.3933-1.55471h-2.0134l-1.1865 4.7513h2.008l.4107-1.64054 1.0738 1.64054h2.4294l-1.7999-2.48832zm-18.1041 2.15969s-.1369 1.54398-1.4523 1.54398h-.745l.6564-2.56346h.6751c.2416.00134.9409.06439.8658 1.01948zm-.1074-2.15701-.5436-.00134h-2.6281l-1.1866 4.74996h2.6107l1.0322.0014c1.4536 0 2.8844-1.08122 2.8844-2.73922.0014-1.94909-2.169-2.0108-2.169-2.0108zm26.2689-.00268-.7006 2.79821-.9329-2.79821h-2.3368l-1.1866 4.7527h1.4523l.7074-2.82239.9369 2.82239h2.3261l1.1878-4.7527z",
    fill: "#00a0e4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaikinOnecta);
export default __webpack_public_path__ + "static/media/daikin-onecta.5d3070d1f4e2b2851901911fa3ee4664.svg";
export { ForwardRef as ReactComponent };